{
  "list": {
    "attributes": {
      "friendlyName": "Name",
      "type": "Type",
      "serialNumber": "Serial number",
      "firmwareVersion": "Firmware version",
      "hardwareVersion": "Hardware version",
      "state": "State",
      "createdAt": "Created at",
      "connectivity": {
        "name": "Connectivity",
        "connected": {
          "lessThan": "The device last connection to the platform is less than {duration} away.",
          "greaterThan": "The device last connection to the platform is greater than {duration} away."
        },
        "duration": {
          "seconds": "{count} seconds | {count} second | {count} seconds",
          "minutes": "{count} minutes | {count} minute | {count} minutes",
          "hours": "{count} hours | {count} hour | {count} hours"
        }
      },
      "metastatus": {
        "name": "Metastatus",
        "status": {
          "success": "All the device latest operations went well.",
          "mixed": "At least one of the device last operations failed.",
          "error": "All the device latest operations have failed."
        }
      },
      "sector": "Sector",
      "actionInProgress": "Actions in progress",
      "certificateExpirationRange": "Certificate"
    }
  },
  "stateValue": {
    "PREPROVISIONED": "Pre-provisioned",
    "REGISTERED": "registered"
  },
  "import": {
    "title": "Import",
    "text": "Import",
    "header": {
      "text": "Import pre-provisioned devices"
    },
    "clickToUpload": "Click to upload",
    "orDragAndDrop": "or drag and drop .ZIP file only",
    "action": {
      "report": "Analyze",
      "execution": "Import"
    },
    "inProgress": {
      "report": "Analysis in progress...",
      "execution": "Import in progress..."
    },
    "results": {
      "report": {
        "total": "No devices detected | 1 device detected | {count} devices detected",
        "succeed": {
          "exist": "Validated devices to update:",
          "new": "Validated devices to create:"
        },
        "failed": "Erroneous devices:"
      },
      "execution": {
        "total": "No devices processed | 1 device processed | {count} devices processed",
        "succeed": {
          "exist": "Updated devices:",
          "new": "Created devices:"
        },
        "failed": "Erroneous devices:"
      }
    },
    "validation": {
      "fileMandatory": "File must be a .ZIP",
      "fileEmpty": "The .ZIP file must not be empty"
    }
  },
  "form": {
    "description": {
      "title": "Description",
      "idCard": {
        "title": "ID card",
        "attributes": {
          "name": "Name",
          "type": "Type",
          "model": "Model",
          "serialNumber": "Serial number",
          "hardwareVersion": "Hardware version",
          "manufacturer": "Manufacturer",
          "sector": "Sector"
        }
      },
      "state": {
        "title": "State",
        "attributes": {
          "state": "State",
          "firstConnection": "First connection",
          "lastConnection": "Last connection",
          "batteryStatus": "Battery status",
          "lastChange": "Last change",
          "configurationApplicationDate": "Configuration application date",
          "lastRebootDate": "Last reboot date",
          "firstCommissioningDate": "Date of the first commissioning",
          "certificateExpirationDate": "Certificate expiration date",
          "firmwareVersion": "Firmware version",
          "latestFirmwareUpdate": "Last firmware update",
          "lastCertificateUpdate": "Last certificate update",
          "lastSynchronisation": "Device last synchronisation:",
          "lastDisconnectionDate": "Last disconnection date"
        }
      },
      "connectivity": {
        "title": "Connectivity",
        "communication": "Communication",
        "simCard": "SIM card",
        "attributes": {
          "antenna": "Antenna",
          "mobileNetwork": "Mobile network",
          "gsmFrequencyBand": "GSM frequency band",
          "communicationProtocol": "Communication protocol",
          "accessPointName": "Access point name (APN)",
          "userName": "User name"
        },
        "status": "Connectivity status"
      },
      "geolocation": {
        "title": "Site description",
        "attributes": {
          "address": "Address",
          "latlong": "Lat: {latitude} - Lon: {longitude}",
          "status": "Geolocation status"
        }
      },
      "characteristics": {
        "title": "Characteristics"
      }
    },
    "configuration": {
      "title": "Configuration",
      "information": {
        "configurationType": {
          "label": "Configuration type",
          "SELF_SUPPORTING": "Self-supporting",
          "GLOBAL_AND_SPECIFIC": "Global + specific"
        },
        "selfSupportingVersion": "Self-supporting version",
        "globalVersion": "Global version",
        "specificVersion": "Specific version",
        "configurationOrigin": "Origin of the configuration",
        "lastUpdate": "Last update"
      },
      "operations": {
        "title": "Operations"
      },
      "upload": {
        "userInformation": {
          "title": "Configuration upload",
          "description": "This configuration will be available only for this device."
        },
        "error": {
          "invalidFileType": "The file must be in JSON or JWT format.",
          "fileSize": "The configuration file must be less than 750 MB.",
          "emptyFile": "The configuration file must not be empty.",
          "fileAlreadyExist": "This configuration file already exists for this device."
        },
        "title": "Configuration upload",
        "confirm": {
          "title": "Configuration upload cancellation",
          "message": "Are you sure you want to cancel the configuration upload?\nAll data will be lost."
        },
        "form": {
          "title": "Configuration information",
          "versionName": "Version name",
          "version": "Version",
          "type": "Type"
        },
        "buttonTooltip": "Upload a configuration",
        "success": "The configuration upload has been successful"
      },
      "update": {
        "title": "Configuration update",
        "warning": "The device has already an operation of the same type scheduled or running",
        "scheduling": {
          "title": "Scheduling",
          "label": "Scheduled the update",
          "placeholder": "Select an update date"
        },
        "configurationSelection": {
          "title": "Configuration",
          "radio": {
            "specific": "Specific",
            "globalAndSpecific": "Global & specific"
          },
          "label": "Select a configuration in the list below",
          "placeholder": "Select a configuration",
          "specific": "Specific configuration",
          "global": "Global configuration"
        },
        "instantSending": {
          "label": "Instant delivery",
          "tooltip": "Operation transmission to the device as soon as possible."
        },
        "cancel": {
          "confirm": {
            "title": "Configuration update cancellation",
            "message": "Are you sure you want to cancel the configuration update?\nAll data will be lost."
          }
        }
      },
      "browse": {
        "selfSupporting": "Browse the self-supporting configurations",
        "specific": "Browse specific configurations"
      },
      "list": {
        "title": {
          "selfSupporting": "Self-supporting configurations",
          "specific": "Specific configurations"
        },
        "search": {
          "placeholder": "Search by version name or version"
        },
        "noConfiguration": "No configuration found",
        "columns": {
          "versionName": "Version name",
          "version": "Version",
          "uploadedDate": "Uploaded date"
        },
        "periodPicker": {
          "placeholder": "Select a period"
        }
      },
      "delete": {
        "selectedConfigurations": "No configurations selected | {count} configuration selected | {count} selected configurations",
        "confirm": {
          "title": "No configurations selected | Delete the configuration | Delete configurations",
          "message": "No configurations selected | Are you sure you want to delete the selected configuration? | Are you sure you want to delete the selected configurations?"
        }
      }
    },
    "dataviz": {
      "title": "Data vizualisation",
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "quarter": "Quarter",
      "newChart": "Drag & drop a data here to create a new chart.",
      "noData": "No data"
    },
    "firmware": {
      "title": "Firmware",
      "state": {
        "attributes": {
          "firmwareVersion": "Version",
          "latestFirmwareUpdate": "Last update"
        }
      },
      "information": {
        "attributes": {
          "latestFirmwareUpdate": "Last update",
          "firmwareUpdateSource": "Origin",
          "firmwareUpdateSourceOption": {
            "mobileApp": "Mobile app",
            "factory": "Factory"
          }
        }
      },
      "updateFirmware": "Update firmware"
    },
    "logs": {
      "title": "Logs",
      "lastOperationReportUpdateDate": {
        "label": "Last operating report upload date"
      },
      "noLogsFound": "No logs found"
    },
    "additionalMetadata": {
      "title": "Additional metadata",
      "options": {
        "title": "Options",
        "processControl": "Process control",
        "pumpingStation": "Pumping stations",
        "webServer": "WEB Server",
        "webMimicDiagram": "Website Mimic Diagram",
        "ipBackup": "IP backup ADSL / GSM",
        "iecSlave": "IEC60870-5-104 Slave",
        "externalControlLiftStation": "External control of Lift Station",
        "pumpingOptimization": "Pumping optimization",
        "dataPoints": "Number of data points: {value}",
        "ioModules": "Number of I/O modules: {value}",
        "comModules": "Number of COM modules: {value}",
        "calendars": "Number of calendars: {value}",
        "schedules": "Number of schedules: {value}",
        "objects": "Number of objects: {value}",
        "allowedLocalPost": "Remote terminal units: {value}",
        "licenceExpirationDate": "License expiry date: {value}",
        "licenceId": "License number: {value}"
      },
      "communicationModules": {
        "title": "Communication modules"
      },
      "modules": {
        "location": "Location",
        "module": "Module"
      },
      "ioModules": {
        "title": "Modules I/O"
      },
      "networkInterfaceCardExtensions": {
        "title": "Network interface card extension(s)"
      },
      "ioCardExtensions": {
        "title": "IO card extension(s)"
      },
      "modemCardExtensions": {
        "title": "Modem card extension(s)"
      },
      "comments": {
        "title": "Comments"
      }
    },
    "certificate": {
      "title": "Certificate",
      "information": {
        "title": "Certificate",
        "attributes": {
          "certificateExpirationDate": "Certificate validity date",
          "lastCertificateUpdate": "Last update of the certificate",
          "origin": "Origin of the certificate",
          "origins": {
            "mobileApplication": "Mobile application",
            "lxConnect": "LX CONNECT"
          }
        }
      }
    }
  },
  "empty": "No device found",
  "lifeCycleState": {
    "preprovisioned": "Pre-provisioned",
    "registered": "Registered",
    "activated": "Activated",
    "disabled": "Disabled",
    "locked": "Locked"
  },
  "filters": {
    "searchByNameOrSerialNumber": "Search by name or serial number",
    "compatibilityQuickFilters": {
      "allDevices": "All devices",
      "compatibleDevices": "Compatible devices",
      "incompatibleDevices": "Incompatible devices"
    },
    "deviceType": "Type",
    "selectionQuickFilters": {
      "allDevices": "All devices",
      "selectedDevices": "Selected devices",
      "unselectedDevices": "Unselected devices"
    },
    "lifecycleState": "State",
    "connectivity": {
      "label": "Connectivity",
      "type": "Device connection type",
      "status": "Status",
      "SHORT_LIVED": "Polling",
      "GOOD": "Less than 24 hours",
      "WARN": "More than 24 hours",
      "ERROR": "More than 72 hours",
      "empty": "No status available",
      "PERSISTENT": "Persistent",
      "ONLINE": "Connected",
      "OFFLINE": "Disconnected"
    },
    "ranges": {
      "label": "Range"
    }
  },
  "fleet": {
    "cancelSelection": "Cancel selection",
    "selectedDevices": "No devices selected | {count} device selected | {count} selected devices",
    "addToFleet": "Add to a fleet",
    "removeFromFleet": "Remove from fleet"
  },
  "deviceFound": "No devices found | {count} device found | {count} devices found",
  "action": {
    "enable": "Enable the device",
    "disable": "Disable the device",
    "confirm": {
      "title": "Disable the device?",
      "description": "Are you sure you want to disable this device? This action will prevent any communication with the platform and all currently running operations will be cancelled.",
      "disable": "Disable"
    },
    "button": {
      "enable": "Enable",
      "disable": "Disable"
    },
    "delete": {
      "tooltip": "Delete device",
      "confirm": {
        "title": "Device deletion",
        "message": "Deleting a device will permanently erase all its data, operations, and telemetry."
      }
    }
  },
  "cartography": {
    "title": "Cartography",
    "deviceMapTile": {
      "button": {
        "seeDevice": "See the device"
      }
    },
    "devicesMap": {
      "noDevices": "No devices to display"
    }
  },
  "globalConfiguration": {
    "automaticRenewalDelay": {
      "information": {
        "title": "Automatic certificate renewal delay",
        "body": "Defines how long before expiry the device certificate will be automatically renewed."
      },
      "label": "Automatic certificate renewal delay",
      "values": {
        "nDay": "1 day | {n} days",
        "nMonth": "1 month | {n} months",
        "nYear": "1 year | {n} years"
      },
      "custom": {
        "label": "Custom",
        "unit": "day | days"
      },
      "error": {
        "required": "The automatic renewal delay is required",
        "minMax": "The automatic renewal delay must be between {min} and {max}"
      }
    },
    "pollingFrequency": {
      "information": {
        "title": "Polling frequency",
        "body": "Defines the time interval between two communications from the device to the platform."
      },
      "label": "Polling frequency",
      "values": {
        "nMinute": "1 minute | {n} minutes",
        "nHour": "1 hour | {n} hours"
      },
      "custom": {
        "label": "Custom",
        "unit": "minute | minutes"
      },
      "error": {
        "required": "The polling frequency is required",
        "minMax": "The polling frequency must be between {min} and {max}"
      }
    }
  }
}
